import { useEffect, useState } from "react";
import Loader from "./Loader";
import { Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBluetooth } from "@fortawesome/free-brands-svg-icons";

function BluetoothAvailabilityInfo() {
    const [availableStatus, setAvailableStatus] = useState(null);

    useEffect(() => {
        if (!navigator || !navigator.bluetooth) {
            setAvailableStatus(false);
        } else {
            navigator.bluetooth.getAvailability().then(available => {
                setAvailableStatus(available);
            });
        }
    }, []);

    return (
        availableStatus === null ? (
            <Loader text="bluetooth.checking" compact />
        ) : availableStatus ? (
            <span className="text-success">
                <FontAwesomeIcon icon={faBluetooth} /> <Trans>bluetooth.available</Trans>
            </span>
        ) : (
            <span className="text-danger">
                <FontAwesomeIcon icon="circle-exclamation" /> <Trans>bluetooth.unavailable</Trans>
            </span >
        )
    );
}
export default BluetoothAvailabilityInfo;